import type {
  Stripe,
  StripeElements,
  SetupIntentResult,
} from "@stripe/stripe-js";

/**
 * On-page 3DS can leave `confirmSetup` pending after success. Poll retrieve
 * for `succeeded` so the form can finish. FR-1292.
 */
export async function confirmSetupIntent(
  stripe: Stripe,
  elements: StripeElements,
  confirmParams: {
    return_url: string;
    payment_method_data?: {
      billing_details?: { address?: { line2?: string | null } };
    };
  },
  clientSecret?: string | null
): Promise<SetupIntentResult> {
  const confirm = stripe.confirmSetup({
    elements,
    confirmParams,
    redirect: "if_required",
  });
  if (!clientSecret) return confirm;

  const poll = (async () => {
    for (let i = 0; i < 60; i++) {
      await new Promise((r) => setTimeout(r, 1500));
      const retrieved = await stripe.retrieveSetupIntent(clientSecret);
      if (retrieved.setupIntent?.status === "succeeded") return retrieved;
    }
    return confirm;
  })();

  return Promise.race([confirm, poll]);
}
